function applySearchSynonyms(terms) {
  const synonyms = new Map();
  (window.searchSynonyms || '').split('\n').forEach((line) => {
    const [term, replacement] = line.split('=').map((part) => part?.trim());
    if (term && replacement) synonyms.set(term.toLowerCase(), replacement);
  });
  if (!synonyms.size) return terms;
  return terms
    .split(/(\s+)/)
    .map((word) => synonyms.get(word.toLowerCase()) ?? word)
    .join('');
}

(() => {
  if (location.pathname !== window.routes?.search_url) return;
  const url = new URL(location.href);
  const terms = url.searchParams.get('q');
  if (!terms) return;
  const replaced = applySearchSynonyms(terms);
  if (replaced === terms || applySearchSynonyms(replaced) !== replaced) return;
  url.searchParams.set('q', replaced);
  location.replace(url);
})();

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', () => {
        this.input.value = applySearchSynonyms(this.input.value);
      });
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
